import React from "react";
import { UiKit } from "@datavant/uikit";
import { RecordHubPageFooter } from "@/components/SmartRequest/RecordHubPageContainer";
import Image from "next/image";
import new_logo from "../../public/new-login-logo.png";
import OktaWidgetNoSSR from "@/components/okta/OktaWidgetNoSSR";
import { Box, Flex } from "@chakra-ui/react";
function OktaWidgetLoginContainer() {
    return (<>
      <Box position={"fixed"} inset={0} bg={UiKit.consistency.gray70} zIndex="-1"/>
      <Flex minH="100vh" align="center" justify="center">
        <Box overflowX={"hidden"}>
          <UiKit.InfoBox width={"md"}>
            <UiKit.Chakra.HStack justify={"center"}>
              <Image src={new_logo} alt="Smart Request" priority width={"270"} height={"91"}/>
            </UiKit.Chakra.HStack>
            <hr style={{
            borderTop: "1px solid black",
            marginLeft: "-10%",
            marginRight: "-10%",
        }}/>
            <UiKit.Hint.Info colored={true}>
              <UiKit.Text.BodyRegular>
                {"Having trouble signing in?"}
                <UiKit.Text.Clickable text="   Help" onClick={() => {
            window.open("/open/login-questions", "_blank");
        }} underline={true}/>
              </UiKit.Text.BodyRegular>
            </UiKit.Hint.Info>
            <UiKit.Chakra.VStack w={"100%"} justify={"center"}>
              <div style={{
            color: UiKit.consistency.brandColors.cancelButton.font,
            fontFamily: "DM Sans",
            fontWeight: 400,
            fontSize: "28px",
            marginTop: "5px",
        }}>
                Smart Request
              </div>
              <OktaWidgetNoSSR />
            </UiKit.Chakra.VStack>
            <div style={{ marginLeft: "68px", marginTop: "0px" }}>
              <UiKit.Chakra.VStack spacing={UiKit.consistency.buffer} align={"left"} width={"270px"}>
                <UiKit.Text.BodyRegular>
                  <span style={{ fontWeight: 700 }}>
                    New to Smart Request?{" "}
                  </span>{" "}
                  Click below to sign up for digital records retrieval from
                  Datavant (formerly Ciox Health) Partner Sites.
                </UiKit.Text.BodyRegular>
                <UiKit.Text.Clickable text="Click here to sign up" onClick={() => {
            window.open("/open/self-registration", "_self");
        }} underline={true}/>
                <RecordHubPageFooter dontShowModals={true}/>
              </UiKit.Chakra.VStack>
            </div>
          </UiKit.InfoBox>
        </Box>
      </Flex>
    </>);
}
export default OktaWidgetLoginContainer;
